import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ProtectedProvider } from "@/features/auth/_providers/protected-provider";
import { QuoteMigrationPage } from "@/features/office/quote-migration";
import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * The temporary scope → quote migration page: full page, no office sidebar,
 * for signed-in coordinators and admins (the page checks the role; the API
 * enforces it). Removed with `features/office/quote-migration`.
 *
 * Lenient strings only — the page narrows them; a strict enum here would throw
 * `SearchParamError` and crash the page (webapp-routing.md).
 */
const searchSchema = z.object({
  tab: z.string().optional(),
  q: z.string().optional(),
  owner: z.string().optional(),
  status: z.string().optional(),
  pattern: z.string().optional(),
  pricedBy: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/custom-app/migrate-to-quote")({
  validateSearch: searchSchema,
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Birdwatch - Scope to Quote" }],
  }),
});

function RouteComponent() {
  return (
    <ProtectedProvider>
      <QuoteMigrationPage />
    </ProtectedProvider>
  );
}
